export default __webpack_public_path__ + "static/media/filipe.910b22ca.png";